import React from 'react';
import styles from '../styles.module.css';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';

export default function BackButton({
  href = `/sub-users?garage=true`,
  text = 'بازگشت به گاراژ',
  onClick,
  color,
}: {
  href?: string;
  text?: string;
  onClick?: () => void;
  color?: string;
}) {
  const Tag = !onClick ? AppLink : 'button';
  return (
    <Tag
      className={styles.backButton}
      href={!onClick ? href : ''}
      onClick={onClick}
      style={{ color: color }}
    >
      <MainIcons.arrowIcon fill={color ? color : 'var(--text-mut2)'} />

      {text}
    </Tag>
  );
}
